import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0D14] p-6">
      <div className="w-full max-w-sm animate-fade-up">
        <h2 className="font-heading text-2xl font-bold text-[#F8FAFC] mb-2">Mot de passe oublié</h2>
        {done ? (
          <div data-testid="forgot-confirmation" className="text-sm text-[#94A3B8] bg-[#182232] border border-[#2A364F] rounded-lg p-4 flex gap-3">
            <MailCheck className="w-5 h-5 text-[#10B981] shrink-0" />
            Si cet email est enregistré, un lien de réinitialisation vient d'être envoyé.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-[#94A3B8]">Entrez votre email pour recevoir un lien de réinitialisation.</p>
            <div>
              <Label className="text-[#94A3B8]">Email</Label>
              <Input
                data-testid="forgot-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1.5 bg-[#182232] border-[#2A364F] text-[#F8FAFC]"
              />
            </div>
            {error && <div className="text-sm text-[#EF4444]">{error}</div>}
            <Button data-testid="forgot-submit-button" type="submit" disabled={loading} className="w-full bg-[#3B82F6] hover:bg-[#2563EB] text-white">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Envoyer le lien"}
            </Button>
          </form>
        )}
        <Link to="/login" className="mt-6 inline-flex items-center gap-2 text-sm text-[#3B82F6] hover:underline">
          <ArrowLeft className="w-4 h-4" /> Retour à la connexion
        </Link>
      </div>
    </div>
  );
}
